module.exports = __webpack_public_path__ + "media/images/team/mariaisabel-80d285f7d485a6e710679112afe3b522.jpg";